<script setup lang="ts">
import type { IBrandConfig } from '@/config/'

interface TProps {
  brandConfig: IBrandConfig
  className: string
}

defineProps<TProps>()
</script>
<template>
  <div
    data-testid="main-logo-symbol"
    :class="`text-primary ${className}`"
    role="image"
    :aria-label="brandConfig.productName"
    aria-roledescription="Image"
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="
        stroke: currentColor;
        fill-rule: evenodd;
        clip-rule: evenodd;
        stroke-linejoin: round;
        stroke-miterlimit: 2;
      "
    >
      <g transform="matrix(2.24756,0,0,2.40696,-28.8863,11.5547)">
        <g transform="matrix(0.963779,0,0,0.899952,11.9872,-5.63083)">
          <path
            d="M10,4.206L10,10.794C10,11.46 9.46,12 8.794,12L4.206,12C3.54,12 3,11.46 3,10.794L3,4.206C3,3.54 3.54,3 4.206,3L8.794,3C9.46,3 10,3.54 10,4.206Z"
          />
        </g>
        <g transform="matrix(0.963779,0,0,0.899952,11.9872,-5.63083)">
          <path
            d="M21,4.206L21,6.794C21,7.46 20.46,8 19.794,8L15.206,8C14.54,8 14,7.46 14,6.794L14,4.206C14,3.54 14.54,3 15.206,3L19.794,3C20.46,3 21,3.54 21,4.206Z"
            opacity="0.7"
          />
        </g>
        <g transform="matrix(0.963779,0,0,0.899952,11.9872,-5.63083)">
          <path
            d="M21,13.206L21,19.794C21,20.46 20.46,21 19.794,21L15.206,21C14.54,21 14,20.46 14,19.794L14,13.206C14,12.54 14.54,12 15.206,12L19.794,12C20.46,12 21,12.54 21,13.206Z"
          />
        </g>
        <g transform="matrix(0.963779,0,0,0.899952,11.9872,-5.63083)">
          <path
            d="M10,17.206L10,19.794C10,20.46 9.46,21 8.794,21L4.206,21C3.54,21 3,20.46 3,19.794L3,17.206C3,16.54 3.54,16 4.206,16L8.794,16C9.46,16 10,16.54 10,17.206Z"
            opacity="0.7"
          />
        </g>
      </g>
    </svg>
  </div>
</template>
